import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';

export interface INavigatorInfosComponentConfiguration extends CM.Component.IConfiguration {
};

export class NavigatorInfosComponent extends CM.Component<
	NavigatorInfosComponent,
	INavigatorInfosComponentConfiguration
> {
	static count = 0;

	static override initialize() {
		CM.Component.initialize.call(this);
		this.declareEventType('renderMode');
		this.declareEventType('resize');
		this.declareEventType('orientation');
	};

	orientation!: 'portrait' | 'landscape' | 'square';
	renderMode: string = 'default'; //mql, app specific
	size = {
		x: 0,
		y: 0
	};
	OS: {
		isLinux: boolean;
		isWindow: boolean;
		isMac: boolean;
		isAndroid: boolean;
		type: 'Linux' | 'Window' | 'Mac' | 'Android' | 'other';
	} = <any>{};
	browser: {
		isFirefox: boolean;
		isChrome: boolean;
		isIE: boolean;
		type: 'Firefox' | 'Chrome' | 'IE' | 'other';
	} = <any>{};
	device: {
		isMobile: boolean;
		isTablet: boolean;
		isDesktop: boolean;
		type: 'desktop' | 'tablet' | 'mobile' | 'other';
	} = <any>{};

	async updateRenderMode(newRenderMode: string) {
		if (newRenderMode === this.renderMode) {
			return;
		}
		const oldRenderMode = this.renderMode;
		this.renderMode = newRenderMode;
		document.body.dataset.renderMode = this.renderMode;
		await this.dispatchEvent('renderMode', {
			details: {
				newRenderMode,
				oldRenderMode
			}
		});
	};

	override async component_start(ev: STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(ev);
		await this.refreshSizeAndOrientation();
	};

	private async refreshSizeAndOrientation() {
		const nsx = document.body.offsetWidth;
		const nsy = document.body.offsetHeight;
		const newSize = {
			x: nsx,
			y: nsy
		};
		const oldSize = this.size;
		if ((newSize.x === oldSize.x) && (newSize.y === oldSize.y)) {
			return;
		}
		const newOrientation = (
			((nsx === nsy) || (Math.abs(nsx - nsy) < 16)) ? 'square' :
				(nsx < nsy) ? 'portrait' :
					'landscape'
		);
		const oldOrientation = this.orientation;
		this.size = newSize;
		this.orientation = newOrientation;
		await this.dispatchEvent('resize', {
			details: {
				newSize,
				oldSize,
				newOrientation,
				oldOrientation
			}
		});
		if (newOrientation !== oldOrientation) {
			await this.dispatchEvent('orientation', {
				details: {
					newSize,
					oldSize,
					newOrientation,
					oldOrientation
				}
			});
		}
	};

	private async onResize() {
		await this.refreshSizeAndOrientation();
	};

	private onScroll() {
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: INavigatorInfosComponentConfiguration
	) {
		super(descriptor, configuration);
		if (NavigatorInfosComponent.count !== 0) {
			this.component_throwUserError('Only one navigatorInfos component is allowed!', {});
		}
		NavigatorInfosComponent.count++;
		window.addEventListener('resize', this.onResize.bind(this));
		document.addEventListener('scroll', this.onScroll.bind(this), true);
		const dd = new (<any>window).DeviceDetector({
			disableGPUInspection : true
		});
		this.OS.isLinux = false;
		this.OS.isWindow = dd.isWindow;
		this.OS.isMac = (
			dd.isIos || dd.isMac || dd.isApple
		);
		this.OS.isAndroid = dd.isAndroid;
		this.OS.type = (
			this.OS.isLinux ? 'Linux' :
				this.OS.isWindow ? 'Window' :
					this.OS.isMac ? 'Mac' :
						this.OS.isAndroid ? 'Android' :
							'other'
		);
		this.browser.isFirefox = dd.browser.isFirefox;
		this.browser.isChrome = dd.browser.isChrome;
		this.browser.isIE = dd.browser.isIE;
		this.browser.type = (
			this.browser.isFirefox ? 'Firefox' :
				this.browser.isChrome ? 'Chrome' :
					this.browser.isIE ? 'IE' :
						'other'
		);
		this.device.isMobile = dd.isIPod || dd.isIPhone || dd.isMobile || dd.isPhone || dd.isSmartphone;
		this.device.isTablet = dd.isIPad || dd.isTablet;
		this.device.isDesktop = dd.isDesktop;
		this.device.type = (
			this.device.isMobile ? 'mobile' :
				this.device.isTablet ? 'tablet' :
					this.device.isDesktop ? 'desktop' :
						'other'
		);
		document.body.dataset.os = this.OS.type;
		document.body.dataset.browser = this.browser.type;
		document.body.dataset.device = this.device.type;
	};
};
export namespace NS {
	export const Component = NavigatorInfosComponent;
	export type Component = NavigatorInfosComponent;
	export type Configuration = INavigatorInfosComponentConfiguration;
}
;
CM.Manager.declare({
	id: 'navigatorInfos',
	type: NavigatorInfosComponent
});
